import { render, staticRenderFns } from "./SummaryRecord.vue?vue&type=template&id=58019de8&scoped=true&"
import script from "./SummaryRecord.vue?vue&type=script&lang=ts&"
export * from "./SummaryRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58019de8",
  null
  
)

export default component.exports